import React from "react";
import { Title } from "../general/index";

const TeamCard = ({ image, name, role }) => {
  return (
    <div className="text-center team__card">
      <img
        className="mb-3 w-64 h-64 rounded-full object-cover"
        src={image}
        alt="Cofounder of Fructify"
      />

      <Title margin="2" fontSize="2xl">
        {name}
      </Title>
      <p className="text-blue text-base">{role}</p>
    </div>
  );
};

export default TeamCard;
